// Accounting Purchases Vuex

import state from './purchaseFixedStates.js'
import * as getters from './purchaseFixedGetters.js'
import * as mutations from './purchaseFixedMutations.js'
import * as actions from './purchaseFixedActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
